<template>
  <div v-if="selectedMasterClass && isOpen">
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  General Surcharge ({{ selectedMasterClass.masterClassName }})
                </h4>
                <h6 v-if="timestampItem">Last Updated: {{ timestampItem }}</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="modal-content-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="col-sm-4 divider-right pr-25">
                      <div class="summary-error" v-if="$v.model.$error">
                        This form has errors
                      </div>
                      <div class="form-group" v-if="serviceType === 1">
                        <label class="required">Zones</label>
                        <multiselect
                          v-model="model.zones"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.zones.required,
                          }"
                          :options="zones"
                          :multiple="true"
                          :close-on-select="false"
                          placeholder="Select zones"
                          label="label"
                          track-by="id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.zones.required"
                        >
                          Zone(s) is required
                        </small>
                      </div>
                      <div class="form-group" v-else>
                        <label class="required">Group Zone</label>
                        <multiselect
                          v-model="model.groupZones"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.groupZones.required,
                          }"
                          :options="groupZones"
                          :multiple="true"
                          :close-on-select="false"
                          placeholder="Select group zones"
                          label="label"
                          track-by="id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.groupZones.required"
                        >
                          Group zone is required
                        </small>
                      </div>
                      <ul class="nav nav-tabs nav-justified tabs-mini-form">
                        <li
                          :class="[
                            activeTab === generalSurchargeType.NightTime
                              ? 'active'
                              : '',
                          ]"
                          @click="
                            onChangeActiveTab(generalSurchargeType.NightTime)
                          "
                        >
                          <a
                            href="#night-surcharge"
                            data-toggle="tab"
                            @click="activeTab = 'nighttime'"
                          >
                            Morning/Night/Peak-Hour
                          </a>
                        </li>
                        <li
                          :class="[
                            activeTab === generalSurchargeType.Weekend
                              ? 'active'
                              : '',
                          ]"
                          @click="
                            onChangeActiveTab(generalSurchargeType.Weekend)
                          "
                        >
                          <a
                            href="#weekend-surcharge"
                            data-toggle="tab"
                            @click="activeTab = 'weekend'"
                          >
                            Weekend
                          </a>
                        </li>
                        <!-- <li
                          :class="[
                            activeTab === generalSurchargeType.GarageTime
                              ? 'active'
                              : '',
                          ]"
                          @click="
                            onChangeActiveTab(generalSurchargeType.GarageTime)
                          "
                        >
                          <a
                            href="#garage-surcharge"
                            data-toggle="tab"
                            @click="activeTab = 'garage'"
                          >
                            Garage
                          </a>
                        </li> -->
                        <!-- <li :class="[activeTab === generalSurchargeType.Others ? 'active' : '']" @click="onChangeActiveTab(generalSurchargeType.Others)">
                          <a href="#others" data-toggle="tab" @click="activeTab = 'others'">
                            Others
                          </a>
                        </li> -->
                      </ul>
                      <div class="tab-content pt-10">
                        <div
                          id="night-surcharge"
                          class="tab-pane fade"
                          :class="[
                            activeTab === generalSurchargeType.NightTime
                              ? 'in active'
                              : '',
                          ]"
                        >
                          <div class="form-group">
                            <label>Start Time</label>
                            <VueCtkDateTimePicker
                              id="nightTimeSurchargeStart"
                              v-model="model.nightTimeSurchargeStart"
                              color="#025BC5"
                              format="HH:mm"
                              formatted="HH:mm"
                              label="Select time"
                              only-time
                              no-label
                              no-button
                            />
                          </div>
                          <div class="form-group">
                            <label>End Time</label>
                            <VueCtkDateTimePicker
                              id="nightTimeSurchargeEnd"
                              v-model="model.nightTimeSurchargeEnd"
                              color="#025BC5"
                              format="HH:mm"
                              formatted="HH:mm"
                              label="Select time"
                              only-time
                              no-label
                              no-button
                            />
                          </div>
                          <div class="form-group">
                            <label>Rate Type</label>
                            <v-select
                              class="v-search-select"
                              placeholder="Select rate type"
                              label="text"
                              v-model="model.rateAmountType"
                              :options="amountTypes"
                              :clearable="false"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.value"
                            />
                          </div>
                          <div class="form-group" v-if="showCurrencyField">
                            <label class="required">Currency</label>
                            <v-select
                              class="v-search-select"
                              :class="{
                                'field-error':
                                  isSubmitted && !$v.model.currency.required,
                              }"
                              placeholder="Select currency"
                              label="text"
                              v-model="model.currency"
                              :options="currencies"
                              :clearable="false"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.value"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="isSubmitted && !$v.model.currency.required"
                            >
                              Currency is required
                            </small>
                          </div>
                          <div class="form-group">
                            <label>Rate</label>
                            <currency-input
                              v-if="
                                model.rateAmountType === 0 ||
                                model.rateAmountType === 1
                              "
                              name="flatRateAmountFlat"
                              class="form-control"
                              autocomplete="off"
                              placeholder="Enter rate"
                              v-model="model.flatRateAmount"
                              :allow-negative="false"
                              :currency="null"
                              :locale="moneyFormat.cultureCode"
                              :precision="moneyFormat.numberOfDecimal"
                            />
                            <input
                              v-else
                              type="number"
                              name="flatRateAmountPercentage"
                              class="form-control"
                              placeholder="Enter rate"
                              v-model="model.flatRateAmount"
                              min="0"
                              step="any"
                            />
                          </div>
                        </div>
                        <div
                          id="weekend-surcharge"
                          class="tab-pane fade"
                          :class="[
                            activeTab === generalSurchargeType.Weekend
                              ? 'in active'
                              : '',
                          ]"
                        >
                          <div class="form-group">
                            <label>Rate Type</label>
                            <v-select
                              class="v-search-select"
                              placeholder="Select rate type"
                              label="text"
                              v-model="model.rateAmountType"
                              :options="amountTypes"
                              :clearable="false"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.value"
                            />
                          </div>
                          <div class="form-group" v-if="showCurrencyField">
                            <label class="required">Currency</label>
                            <v-select
                              class="v-search-select"
                              :class="{
                                'field-error':
                                  isSubmitted && !$v.model.currency.required,
                              }"
                              placeholder="Select currency"
                              label="text"
                              v-model="model.currency"
                              :options="currencies"
                              :clearable="false"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.value"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="isSubmitted && !$v.model.currency.required"
                            >
                              Currency is required
                            </small>
                          </div>
                          <div class="form-group">
                            <label>Rate</label>
                            <currency-input
                              v-if="
                                model.rateAmountType === 0 ||
                                model.rateAmountType === 1
                              "
                              name="flatRateAmountFlat"
                              class="form-control"
                              autocomplete="off"
                              placeholder="Enter rate"
                              v-model="model.flatRateAmount"
                              :allow-negative="false"
                              :currency="null"
                              :locale="moneyFormat.cultureCode"
                              :precision="moneyFormat.numberOfDecimal"
                            />
                            <input
                              v-else
                              type="number"
                              name="flatRateAmountPercentage"
                              class="form-control"
                              placeholder="Enter rate"
                              v-model="model.flatRateAmount"
                              min="0"
                              step="any"
                            />
                          </div>
                          <div class="form-group">
                            <label>Days</label>
                            <multiselect
                              v-model="model.weekendSurchargeDays"
                              :options="weekends"
                              :multiple="true"
                              :close-on-select="false"
                              placeholder="Select day"
                              label=""
                              track-by=""
                            />
                          </div>
                        </div>
                        <!-- <div
                          id="garage-surcharge"
                          class="tab-pane fade"
                          :class="[
                            activeTab === generalSurchargeType.GarageTime
                              ? 'in active'
                              : '',
                          ]"
                        >
                          <div class="form-group">
                            <label> Fixed Rate </label>
                            <currency-input
                              name="garageTimeFixedRate"
                              class="form-control"
                              autocomplete="off"
                              placeholder="Enter rate"
                              v-model="model.flatRateAmount"
                              :allow-negative="false"
                              :currency="null"
                              :locale="moneyFormat.cultureCode"
                              :precision="moneyFormat.numberOfDecimal"
                            />
                          </div>
                          <div class="form-group">
                            <label>Duration Band (minute)</label>
                            <input
                              type="number"
                              name="garageTimeBandMinutes"
                              class="form-control"
                              v-model="model.garageTimeBandMinutes"
                              min="0"
                            />
                          </div>
                          <div class="form-group">
                            <label>Minimum Band</label>
                            <input
                              type="number"
                              name="garageTimeBandMinimum"
                              class="form-control"
                              v-model="model.garageTimeBandMinimum"
                              min="0"
                            />
                          </div>
                        </div> -->
                        <!-- <div id="others" class="tab-pane fade" :class="[activeTab === generalSurchargeType.Others ? 'in active' : '']">
                          <div class="form-group">
                            <label>Minimum Hire (hour)</label>
                            <input
                              type="number"
                              name="minimumHourlyHire"
                              class="form-control"
                              v-model="model.minimumHourlyHire"
                              min="0"
                            />
                          </div>
                          <div class="form-group">
                            <label>Rounding Time (minute)</label>
                            <input
                              type="number"
                              name="minuteRoundingTime"
                              class="form-control"
                              v-model="model.minuteRoundingTime"
                              min="0"
                            />
                          </div>
                          <div class="form-group">
                            <label>Remark</label>
                            <textarea
                              class="form-control"
                              rows="3"
                              name="remark"
                              v-model="model.remark"
                            />
                          </div>
                        </div> -->
                      </div>
                      <div
                        class="modal-footer"
                        v-if="isAllowToCreate || isAllowToUpdate"
                      >
                        <button
                          type="button"
                          class="btn btn-default"
                          @click.prevent="onResetForm()"
                        >
                          Reset
                        </button>
                        <button
                          v-if="!isUpdate && isAllowToCreate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Create
                        </button>
                        <button
                          v-if="isUpdate && isAllowToUpdate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-8 pl-20">
                      <div class="table-modal-detail">
                        <div
                          class="table-responsive table-accordion"
                          v-if="activeTab"
                        >
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th class="number">No</th>
                                <th>Zones</th>

                                <template
                                  v-if="
                                    activeTab === generalSurchargeType.NightTime
                                  "
                                >
                                  <th class="text-center">Start Time</th>
                                  <th class="text-center">End Time</th>
                                  <th class="text-center">Rate Type</th>
                                  <th class="text-center">Rate</th>
                                </template>

                                <template
                                  v-if="
                                    activeTab === generalSurchargeType.Weekend
                                  "
                                >
                                  <th class="text-center">Rate Type</th>
                                  <th class="text-center">Rate</th>
                                  <th>Days</th>
                                </template>

                                <template
                                  v-if="
                                    activeTab ===
                                    generalSurchargeType.GarageTime
                                  "
                                >
                                  <th class="text-center">Rate</th>
                                  <th>Duration Band</th>
                                  <th>Minimum Band</th>
                                </template>

                                <th class="text-center" style="width: 120px">
                                  Status
                                </th>
                                <th class="text-center" style="width: 100px">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in surcharges"
                                :key="index"
                              >
                                <td class="text-center pl-10 pr-10">
                                  {{ index + 1 }}
                                </td>
                                <td class="pl-10 pr-10">
                                  <template
                                    v-if="
                                      item.zones &&
                                      item.zones.length > 0 &&
                                      serviceType === 1
                                    "
                                  >
                                    <p
                                      class="mb-0"
                                      v-for="(zoneItem, idxZone) in item.zones"
                                      :key="idxZone"
                                    >
                                      {{
                                        `${zoneItem.group} - ${zoneItem.name}`
                                      }}
                                    </p>
                                  </template>
                                  <template
                                    v-else-if="
                                      item.zoneGroups &&
                                      item.zoneGroups.length > 0 &&
                                      serviceType === 2
                                    "
                                  >
                                    <p
                                      class="mb-0"
                                      v-for="(
                                        zoneItem, idxZone
                                      ) in item.zoneGroups"
                                      :key="idxZone"
                                    >
                                      {{ zoneItem.name }}
                                    </p>
                                  </template>
                                  <template v-else> - </template>
                                </td>

                                <template
                                  v-if="
                                    activeTab === generalSurchargeType.NightTime
                                  "
                                >
                                  <td class="text-center pl-10 pr-10">
                                    {{ item.nightTimeSurchargeStart }}
                                  </td>
                                  <td class="text-center pl-10 pr-10">
                                    {{ item.nightTimeSurchargeEnd }}
                                  </td>
                                  <td class="text-center pl-10 pr-10">
                                    {{ item.amountTypeDescription }}
                                  </td>
                                  <td class="text-right pl-10 pr-10">
                                    {{
                                      renderRateIntoTable(
                                        item.amountType,
                                        item.flatRateAmount,
                                        item.currency
                                      )
                                    }}
                                  </td>
                                </template>

                                <template
                                  v-if="
                                    activeTab === generalSurchargeType.Weekend
                                  "
                                >
                                  <td class="text-center pl-10 pr-10">
                                    {{ item.amountTypeDescription }}
                                  </td>
                                  <td class="text-right pl-10 pr-10">
                                    {{
                                      renderRateIntoTable(
                                        item.amountType,
                                        item.flatRateAmount,
                                        item.currency
                                      )
                                    }}
                                  </td>
                                  <td class="pl-10 pr-10">
                                    {{
                                      renderDaysIntoTable(
                                        item.weekendSurchargeDays
                                      )
                                    }}
                                  </td>
                                </template>

                                <template
                                  v-if="
                                    activeTab ===
                                    generalSurchargeType.GarageTime
                                  "
                                >
                                  <td class="pl-10 pr-10">
                                    {{ item.currency }}
                                    {{ printMoney(item.flatRateAmount) }}
                                  </td>
                                  <td class="pl-10 pr-10">
                                    {{ item.garageTimeBandMinutes }}
                                  </td>
                                  <td class="pl-10 pr-10">
                                    {{ item.garageTimeBandMinimum }}
                                  </td>
                                </template>

                                <td class="text-center">
                                  <label class="cursor-pointer">
                                    <input
                                      type="checkbox"
                                      class="control-checkbox"
                                      v-model="item.isActive"
                                      :disabled="!isAllowToUpdate"
                                      @change="onChangeStatus(item)"
                                    />
                                    <span
                                      class="pl-5 font-weight-normal v-align-middle"
                                    >
                                      {{
                                        item.isActive ? "Active" : "Inactive"
                                      }}
                                    </span>
                                  </label>
                                </td>
                                <td class="text-center">
                                  <div class="button-action-wrapper">
                                    <button
                                      v-if="isAllowToUpdate"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onEdit(item)"
                                    >
                                      <span>Edit</span>
                                    </button>
                                    <button
                                      v-if="isAllowToDelete"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onDelete(item)"
                                    >
                                      <i class="ic-close"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <loader :content="msg" :visible="isLoading" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import { tryParseFloat, tryParseInt } from "@/helpers/numberHelper";
import {
  AmountTypes,
  DaysArray,
  GeneralSurchargeType,
} from "@/models/constants";
import sellingTariffGeneralSurchargeService from "@/services/master/sellingTariff/sellingTariffGeneralSurchargeService.js";

const defaultModel = {
  id: null,
  masterClassId: null,
  type: null,
  currency: null,
  rateAmountType: 1, // flat
  flatRateAmount: null,
  hourlyRateAmount: null,
  garageTimeBandMinimum: null,
  garageTimeBandMinutes: null,
  nightTimeSurchargeStart: "19:00",
  nightTimeSurchargeEnd: "06:59",
  weekendSurchargeDays: [],
  minimumHourlyHire: null,
  minuteRoundingTime: null,
  remark: null,
  isActive: true,
  zones: [],
  groupZones: [],
};

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    showCurrencyField() {
      return this.model.rateAmountType !== 2;
    },
    validationCurrencyField() {
      return this.model.rateAmountType !== 2 ? { required } : {};
    },
  },
  props: ["serviceType"],
  data() {
    return {
      isLoading: false,
      msg: "Please wait",
      isOpen: false,
      selectedMasterClass: null,
      isUpdate: false,
      moneyFormat: null,
      formatter: null,
      timestampItem: null,
      activeTab: GeneralSurchargeType.NightTime,
      isSubmitted: false,
      itemIdToBeDeleted: null,
      model: {},
      amountTypes: AmountTypes,
      weekends: DaysArray,
      generalSurchargeType: GeneralSurchargeType,
      allPermissions: [],
      currencies: [],
      zones: [],
      groupZones: [],
      surcharges: [],
    };
  },
  validations() {
    const v = {
      model: {
        currency: this.validationCurrencyField,
        zones: { required },
        groupZones: {},
      },
    };

    if (this.serviceType === 2) {
      v.model = {
        currency: this.validationCurrencyField,
        zones: {},
        groupZones: { required },
      };
    }
    return v;
  },
  created() {
    this.$eventBus.$on(
      "initializeSellingTariffGeneralSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffGeneralSurcharge");
  },
  methods: {
    async initialize(
      masterClass,
      moneyFormat,
      formatter,
      currencies,
      zones,
      groupZone
    ) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedMasterClass = masterClass;
        this.moneyFormat = moneyFormat;
        this.formatter = formatter;
        this.currencies = currencies;
        this.zones = zones;
        this.groupZones = groupZone;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["SellingTariffGeneralSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.activeTab = this.generalSurchargeType.NightTime;

          this.getAll().then(() => {
            $(this.$refs.vuemodal).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.onResetForm();
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
    onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    onChangeActiveTab(type) {
      this.activeTab = type;
      this.getAll();
    },
    async onChangeStatus(item) {
      this.isLoading = true;
      this.isUpdate = true;
      this.bindModel(item);
      this.model.isActive = !!this.model.isActive;

      try {
        const payload = this.constructPayload();
        await this.submitUpdate(payload);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = Object.assign({}, defaultModel);
    },
    bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      // this.model.amountType = item.amountType;
      this.model.currency = item.currency;
      this.model.rateAmountType = item.amountType;
      this.model.flatRateAmount = item.flatRateAmount;
      this.model.hourlyRateAmount = item.hourlyRateAmount;
      this.model.garageTimeBandMinimum = item.garageTimeBandMinimum;
      this.model.garageTimeBandMinutes = item.garageTimeBandMinutes;
      this.model.minimumHourlyHire = item.minimumHourlyHire;
      this.model.minuteRoundingTime = item.minuteRoundingTime;
      this.model.nightTimeSurchargeStart = item.nightTimeSurchargeStart;
      this.model.nightTimeSurchargeEnd = item.nightTimeSurchargeEnd;
      this.model.weekendSurchargeDays = item.weekendSurchargeDays;
      this.model.remark = item.remark;
      this.model.isActive = item.isActive;
      this.model.zones = null;
      this.model.groupZones = null;
      if (item.zones !== null) {
        this.model.zones = this.zones.filter((array) =>
          item.zones.some((filter) => filter.id === array.id)
        );
      }
      if (item.zoneGroups !== null) {
        this.model.groupZones = this.groupZones.filter((array) =>
          item.zoneGroups.some((filter) => filter.id === array.id)
        );
      }
    },
    constructPayload() {
      const payload = Object.assign({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.type = this.activeTab;
      payload.currency = this.model.currency;
      payload.rateAmountType = this.model.rateAmountType;
      payload.flatRateAmount = tryParseFloat(this.model.flatRateAmount);
      payload.hourlyRateAmount = tryParseFloat(this.model.hourlyRateAmount);
      if (this.model.zones !== null) {
        payload.zones = this.model.zones.map((zone) => zone.id);
      }
      if (this.model.groupZones !== null) {
        payload.groupZones = this.model.groupZones.map((zone) => zone.id);
      }
      payload.serviceType = this.serviceType;

      if (this.activeTab === this.generalSurchargeType.NightTime) {
        payload.nightTimeSurchargeStart = this.model.nightTimeSurchargeStart;
        payload.nightTimeSurchargeEnd = this.model.nightTimeSurchargeEnd;
      }

      if (this.activeTab === this.generalSurchargeType.Weekend) {
        payload.weekendSurchargeDays = this.model.weekendSurchargeDays;
      }

      if (this.activeTab === this.generalSurchargeType.GarageTime) {
        payload.flatRateAmount = tryParseInt(this.model.flatRateAmount);
        payload.garageTimeBandMinimum = tryParseInt(
          this.model.garageTimeBandMinimum
        );
        payload.garageTimeBandMinutes = tryParseInt(
          this.model.garageTimeBandMinutes
        );
      }

      if (this.activeTab === this.generalSurchargeType.Others) {
        payload.minimumHourlyHire = tryParseInt(this.model.minimumHourlyHire);
        payload.minuteRoundingTime = tryParseInt(this.model.minuteRoundingTime);
        payload.remark = this.model.remark;
      }

      return payload;
    },
    async onSubmitForm() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;
        const payload = this.constructPayload();
        if (this.isUpdate) {
          await this.submitUpdate(payload);
        } else {
          await this.submitCreate(payload);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAll() {
      try {
        this.isLoading = true;
        this.surcharges = await sellingTariffGeneralSurchargeService.getAll(
          this.selectedMasterClass.masterClassId,
          this.activeTab,
          this.serviceType
        );
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    async submitCreate(payload) {
      await sellingTariffGeneralSurchargeService.create(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully created.", {
          title: "Success",
        });
      });
    },
    async submitUpdate(payload) {
      await sellingTariffGeneralSurchargeService.update(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
      });
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await sellingTariffGeneralSurchargeService.delete(
          this.itemIdToBeDeleted
        );
        this.itemIdToBeDeleted = null;

        this.getAll().then(() => {
          this.$notification.success("Successfully deleted.", {
            title: "Success",
          });
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    printMoney(value) {
      return this.formatter
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    renderRateIntoTable(amountType, amount, currency) {
      if (amountType === 1) {
        if (amount) {
          return `${currency} ${this.printMoney(amount)}`;
        } else {
          return "-";
        }
      }

      if (amountType === 2) {
        if (amount) {
          return `${amount} %`;
        } else {
          return "-";
        }
      }
    },
    renderDaysIntoTable(days) {
      if (days && days.length > 0) {
        return days.join(", ");
      } else {
        return "-";
      }
    },
  },
  watch: {
    // 'model.garageTimeBandMinutes': {
    //   deep: true,
    //   handler(v) {
    //     if (v !== undefined && (v !== null && v.length === 0)) {
    //       this.model.garageTimeBandMinutes = 0;
    //     }
    //   }
    // },
    // 'model.garageTimeBandMinimum': {
    //   deep: true,
    //   handler(v) {
    //     if (v !== undefined && (v !== null && v.length === 0)) {
    //       this.model.garageTimeBandMinimum = 0;
    //     }
    //   }
    // },
  },
};
</script>

<style>
.header-picker {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/GeneralSurcharge.vue